import { useEffect, useState } from 'react'
import useUserStore from 'store/useUserStore'
import { useNavigate } from 'react-router-dom'
import { isMobile } from 'react-device-detect'
import useGetMakeTotal from 'hooks/query/useGetMakeTotal'
import CountUp from 'react-countup'
import { Button } from 'components/atom/Button'
import { FAQ } from 'components/FAQ'
import { FreePlanModal } from 'components/FreePlanModal'
import { usePostExperiencePlan } from 'hooks/query/usePostExperiencePlan'
import { Modal } from 'components/layout/Modal'
import { getUtmLocalStorage, renderPaybackHome, UserType } from 'utils/common'
import { FreeButton } from 'components/atom/FreeButton'
import classNames from 'classnames'
import { HomePopup } from 'components/popup/HomePopup'
import useGetPopupContent from 'hooks/query/useGetPopupContent'
import { adFreeExperienceBtnClick, freeExperienceBtnClick } from 'utils/metaAd'
import { useSaveUtm } from 'hooks/query/useSaveUtm'
import { useCookies } from 'react-cookie'
import usePrevStore from 'store/usePrevStore'
import { Helmet } from 'react-helmet-async'
import useTranslation from 'hooks/useTranslation'

const Home = () => {
  const { t } = useTranslation()
  const [cookies, setCookies] = useCookies(['fast_cut_popup'])
  const urlParams = new URLSearchParams(window.location.search)

  const { mutate: saveUtmMutate } = useSaveUtm()
  const { mutate: experiencePlanMutate } = usePostExperiencePlan()
  const { data: popupContent } = useGetPopupContent()

  const navigate = useNavigate()
  const userInfo = useUserStore((state: any) => state.userInfo)
  const [buttonPosition, setButtonPosition] = useState('bottom')
  const [isFreePlanModal, SetFreePlanModal] = useState<boolean>(false)
  const [isPopupModal, setPopupModal] = useState<boolean>(true)
  const [isPlan, setIsPlan] = useState<boolean>(false)
  const [isInAppBrowserModal, setInAppBrowserModal] = useState<boolean>(false)

  const prevSet = usePrevStore((state: any) => state.set)

  const [totalCount, setTotalCount] = useState(0)
  const { data: _totalCount } = useGetMakeTotal()

  const paymentFreePlan = () => {
    if (!userInfo?.userInfo) {
      navigate('/sign-up')
      return
    } else if (userInfo && userInfo?.userType === UserType.체험) {
      navigate('/video-editor')
      return
    }

    const utmData = getUtmLocalStorage()
    if (utmData?.utmSource) {
      utmData.trackType = 'FREE_EXPERIENCE'
      saveUtmMutate(utmData, {
        onSuccess: () => {},
        onError: () => {},
      })
      adFreeExperienceBtnClick()
    } else {
      freeExperienceBtnClick()
    }

    experiencePlanMutate('', {
      onSuccess: (data) => {
        navigate('/video-editor')
      },
      onError: () => {
        setIsPlan(true)
      },
    })
  }

  const handleOpenExternalBrowser = () => {
    const url = window.location.href // 현재 페이지 URL
    const userAgent: string =
      navigator.userAgent || navigator.vendor || (window as any).opera
    if (/android/i.test(userAgent)) {
      // 크롬에서 열기 위한 intent URL
      const intentUrl = `intent://${url.replace(
        /^https?:\/\//,
        ''
      )}#Intent;scheme=https;package=com.android.chrome;end;`
      window.location.href = intentUrl // 외부 브라우저로 열기
    } else {
      setInAppBrowserModal(false)
    }
    //window.open(url, '_blank') // 새 창으로 외부 브라우저에서 열기
  }

  useEffect(() => {
    if (_totalCount !== undefined) {
      setTotalCount(_totalCount)
    }
  }, [_totalCount])

  const onClickTextArea = (clickType: string, pathName: string) => {
    if (userInfo) {
      navigate(pathName)
    } else {
      if (clickType === 'long') {
        prevSet({ prevUrl: '/challenge' })
      } else if (clickType === 'short') {
        prevSet({ prevUrl: '/short-video-editor' })
      }

      navigate('/sign-up')
    }
  }
  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY + window.innerHeight
      const documentHeight = document.documentElement.scrollHeight
      const offset = 100

      if (scrollPosition >= documentHeight - offset) {
        setButtonPosition('up')
      } else {
        setButtonPosition('bottom')
      }
    }

    window.addEventListener('scroll', handleScroll)

    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [buttonPosition])

  useEffect(() => {
    if (isFreePlanModal) {
      document.body.classList.add('overflow-hidden') // Tailwind 유틸리티 클래스 사용
    } else {
      document.body.classList.remove('overflow-hidden')
    }
  }, [isFreePlanModal])

  return (
    <>
      <Helmet>
        <title>{t('home.seo.title')}</title>
        <meta
          name="description"
          content={t('home.seo.description')}
        />
        <link rel="canonical" href="https://fastcut.fastseller.shop" />
      </Helmet>
      <div className=" md:max-w-[816px] max-w-[375px] my-0 mx-auto flex flex-col items-center ">
        {/* 홈화면 첫번째 */}
        {renderPaybackHome(userInfo) && (
          <div className="mb-[30px]">{renderPaybackHome(userInfo)}</div>
        )}
        <div className="flex flex-col gap-[20px] w-[343px] md:w-[816px]">
          <div className="flex flex-col items-center">
            {isMobile ? (
              <p
                className="md:text-[64px] text-[44px] font-[800] text-center leading-[50px]"
                style={{
                  background: 'linear-gradient(90deg, #00D2D4, #4360EC)',
                  WebkitBackgroundClip: 'text',
                  WebkitTextFillColor: 'transparent',
                }}
              >
                {t('home.hero.titleMobileLines.line1')} <br />
                {t('home.hero.titleMobileLines.line2')} <br />
                {t('home.hero.titleMobileLines.line3')} <br />
                {t('home.hero.titleMobileLines.line4')}{' '}
              </p>
            ) : (
              <>
                <p
                  className="md:text-[64px] text-[48px] font-[800] text-center"
                  style={{
                    background: 'linear-gradient(90deg, #00D2D4, #4360EC)',
                    WebkitBackgroundClip: 'text',
                    WebkitTextFillColor: 'transparent',
                  }}
                >
                  {t('home.hero.title')}
                </p>{' '}
              </>
            )}
            <br />

            <div className="flex flex-col items-center  mt-6 relative md:text-[18px] text-base">
              <div className="flex items-center gap-[4px]">
                <span className="flex items-center gap-[1px]">
                  {' '}
                  <img
                    src="assets/img/coupang_icon.png"
                    alt="coupang"
                    width={17.76}
                    height={17.42}
                  />
                  {!isMobile && t('home.hero.partners.coupang')}
                </span>
                <span className="flex items-center gap-[1px]">
                  {' '}
                  <img
                    src="assets/img/naver_icon.png"
                    alt="naver"
                    width={17.76}
                    height={17.42}
                  />
                  {!isMobile && t('home.hero.partners.naver')}
                </span>

                <span className="flex items-center gap-[1px]">
                  {' '}
                  <img
                    src="assets/img/ali_icon.png"
                    alt="ali"
                    width={17.76}
                    height={17.42}
                  />
                  {!isMobile && t('home.hero.partners.ali')}
                </span>

                <p> {t('home.hero.description.part1')}</p>
              </div>
              <p className="">
                <span className=" font-bold"> FASTCUT</span>{t('home.hero.description.part2')}
              </p>
              <p>{t('home.hero.description.part3')}</p>
            </div>
            {isMobile ? (
              <p className="w-[100%] mt-6  flex items-end">
                <video
                  playsInline
                  autoPlay
                  muted
                  loop
                  className=" rounded-[10px] w-full"
                >
                  <source
                    src="https://pub.angelleague.io/fast_cut_front/video/home0820.mp4"
                    type="video/mp4"
                  />
                </video>
              </p>
            ) : (
              <p className="mt-6  flex items-end">
                <video
                  playsInline
                  autoPlay
                  muted
                  loop
                  className=" rounded-[10px] w-full"
                >
                  <source
                    src="https://pub.angelleague.io/fast_cut_front/video/home0820.mp4"
                    type="video/mp4"
                  />
                </video>
              </p>
            )}
          </div>
        </div>
        <div className="statusCnt flex flex-col items-center gap-[16px] w-[343px] md:w-[816px] my-[80px] md:my-[80px]">
          <div>
            <p className="text-[34px] md:text-[40px] text-main font-bold text-center">
              {t('home.stats.title')} {isMobile && <br />}{' '}
              <span className="text-black">{t('home.stats.videosGenerated')}</span>
            </p>
          </div>
          <div>
            <p className="text-[64px] md:text-[96px] font-[800]">
              <span>
                <CountUp end={totalCount} duration={2} separator="," />
              </span>{' '}
              <span className=" text-[36px] md:text-[40px]">{t('home.stats.count')}</span>
            </p>
          </div>
        </div>
        <div className="flex flex-col">
          <p className="w-full text-center font-bold md:text-[40px] text-[34px]">
            <span className="text-main">FastCut</span> {isMobile && <br />}
            {t('home.features.videoSample')}
          </p>
          <div className="home_fifth flex w-[100vw] flex-col md:flex-row  mb-[80px] gap-2 ">
            {' '}
            <div className="w-full md:w-[67%]">
              <video
                playsInline
                controls
                autoPlay
                muted
                loop
                className="border rounded-[10px] w-full"
                src="https://s3.ap-northeast-2.amazonaws.com/pub.angelleague.io/fast_cut_front/video/prodcut_1.mp4"
              />
            </div>
            <div className="flex flex-col w-full md:w-[33%] gap-2">
              <div className="">
                <video
                  playsInline
                  controls
                  loop
                  autoPlay
                  muted
                  className="border rounded-[10px]"
                  src="https://s3.ap-northeast-2.amazonaws.com/pub.angelleague.io/fast_cut_front/video/product_2.mp4"
                />
              </div>
              <div className="">
                <video
                  playsInline
                  loop
                  controls
                  autoPlay
                  muted
                  className="border rounded-[10px]"
                  src="https://s3.ap-northeast-2.amazonaws.com/pub.angelleague.io/fast_cut_front/video/product_3.mp4"
                />
              </div>
            </div>
          </div>
        </div>
        <div className="flex flex-col items-center gap-[16px] w-[343px] md:w-[816px] mb-[80px]">
          <div className="flex flex-col items-center gap-4">
            <p className="md:text-[48px] text-[34px] font-bold text-center">
              {t('home.features.title')}
            </p>
            <p className="md:text-[18px] text-base text-center">
              {t('home.features.subtitle')}
            </p>
            <Button
              className={classNames(
                ' px-[23px] py-[13px] border-none rounded-[48px] text-white font-bold',
                {
                  'bg-href': !userInfo,
                  'bg-main': userInfo,
                }
              )}
              onClick={() => {
                onClickTextArea('long', '/video-editor')
              }}
            >
              {userInfo ? t('home.features.startNow') : t('home.features.signUpAndTry')}
            </Button>
          </div>
          <div className="flex flex-col md:flex-row gap-2 ">
            <div className="first flex flex-col bg-[#F6F8FB] p-5 rounded-[40px] gap-2 w-full md:w-[33%]">
              <div className="flex flex-col gap-10">
                <div>
                  <img src="assets/img/home/longform_1.png" alt="1" />
                </div>
                <div>
                  <p className="font-bold text-[8px]">PREMIUM 1</p>
                  <p className="text-[18px] font-bold">
{t('home.features.premium1.title')}
                  </p>
                  <p className="mt-10">
                    {t('home.features.premium1.description')}
                  </p>
                </div>
              </div>
            </div>
            <div className="first flex flex-col bg-[#F6F8FB] p-5 rounded-[40px] gap-2 w-full md:w-[33%]">
              <div className="flex flex-col gap-10">
                <div>
                  <img src="assets/img/home/longform_2.png" alt="1" />
                </div>
                <div>
                  <p className="font-bold text-[8px]">PREMIUM 2</p>
                  <p className="text-[18px] font-bold">{t('home.features.premium2.title')}</p>
                  <p className="mt-10">
                    {t('home.features.premium2.description')}
                  </p>
                </div>
              </div>
            </div>
            <div className="first flex flex-col bg-[#F6F8FB] p-5 rounded-[40px] gap-2  w-full md:w-[33%]">
              <div className="flex flex-col gap-10">
                <div>
                  <img src="assets/img/home/longform_3.png" alt="1" />
                </div>
                <div>
                  <p className="font-bold text-[8px]">PREMIUM 3</p>
                  <p className="text-[18px] font-bold">
{t('home.features.premium3.title')}
                  </p>
                  <p className="mt-10">
                    {t('home.features.premium3.description')}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="flex flex-col md:flex-row items-center gap-[40px] w-[343px] md:w-[816px]  mb-[80px] md:mb-[120px]">
          <div className="w-full flex items-center justify-center md:w-[50%]">
            <img
              src="assets/img/ali_coupang_naver.png"
              alt="ali_coupang"
              className=" h-[324x] md:h-[324px] w-[325px] md:w-[393px]"
            />
          </div>
          <div className="w-[343px] md:w-[50%] flex flex-col items-center md:items-start gap-[16px]">
            <p className="text-[34px] md:text-[40px] font-bold w-[343px] md:w-[388px] leading-[40.8px] md:leading-[48px]">
              {t('home.affiliates.title')}
            </p>
            <p className="text-[#2E343D] leading-[21.6px]  md:text-[18px] w-[343px] md:-[388px]">
              {t('home.affiliates.description')}
            </p>
            <div className="flex justify-end md:justify-start w-full pr-[20px]">
              <Button
                className={classNames(
                  ' px-[23px] py-[13px] border-none rounded-[48px] text-white font-bold',
                  {
                    'bg-href': !userInfo,
                    'bg-main': userInfo,
                  }
                )}
                onClick={() => {
                  onClickTextArea('long', '/video-editor')
                }}
              >
                {userInfo ? t('home.affiliates.startNow') : t('home.affiliates.signUpAndTry')}
              </Button>
            </div>
          </div>
        </div>
        <div className="flex flex-col md:flex-row gap-[16px] md:gap-[40px] w-[343px] md:w-[816px]  mb-[80px] md:mb-[120px]">
          <div className="md:w-[50%] flex flex-col gap-[16px]">
            <p className="md:text-[40px] text-[34px] md:leading-[48px] leading-[40px] font-bold">
              {t('home.results.title')}
            </p>
            <p className=" leading-[21.6px]">
              {t('home.results.description')}
            </p>
            {!isMobile && (
              <div>
                <Button
                  className={classNames(
                    ' px-[23px] py-[13px] border-none rounded-[48px] text-white font-bold',
                    {
                      'bg-href': !userInfo,
                      'bg-main': userInfo,
                    }
                  )}
                  onClick={() => {
                    onClickTextArea('long', '/video-editor')
                  }}
                >
                  {userInfo ? t('home.results.startNow') : t('home.results.signUpAndTry')}
                </Button>
              </div>
            )}
          </div>
          <div className="w-[100%] md:w-[50%] flex items-center">
            <img
              src="assets/img/home_picture1.png"
              width={388}
              height={232}
              alt="home1"
            />
          </div>
          {isMobile && (
            <div className="flex justify-end">
              <Button
                className={classNames(
                  ' px-[23px] py-[13px] border-none rounded-[48px] text-white font-bold',
                  {
                    'bg-href': !userInfo,
                    'bg-main': userInfo,
                  }
                )}
                onClick={() => {
                  onClickTextArea('long', '/video-editor')
                }}
              >
                {userInfo ? t('home.affiliates.startNow') : t('home.affiliates.signUpAndTry')}
              </Button>
            </div>
          )}

          {isFreePlanModal && (
            <FreePlanModal
              isFreePlanModal={isFreePlanModal}
              setFreePlanModal={SetFreePlanModal}
            />
          )}
          {isPlan && (
            <Modal isModal={isPlan}>
              <div className="bg-white w-[400px] h-[184px] p-[20px] border-t rounded-t-[20px]">
                <div className="flex flex-col items-center justify-center h-full gap-[24px]">
                  <p className="font-bold text-[18px]">
                    {t('home.modals.planExists.title')}
                  </p>
                  <div>
                    <p className="">
                      {t('home.modals.planExists.message')}
                    </p>
                  </div>
                </div>
              </div>
              <div className="w-[400px] bg-main h-[60px] border-b border-main rounded-b-[20px] flex justify-center items-center">
                <button
                  className="text-white w-[400px]"
                  onClick={() => {
                    setIsPlan(false)
                  }}
                >
                  {t('home.modals.planExists.confirm')}
                </button>
              </div>
            </Modal>
          )}
        </div>
        <div
          className="home_fifth flex flex-col items-center justify-center gap-[16px] w-[100vw] h-[680px] mb-[80px] "
          style={{
            backgroundImage: 'url(./assets/img/home/fifth.png)',
            backgroundPosition: 'center',
            backgroundSize: 'cover',
          }}
        >
          <p className="text-white md:text-[24px] text-[20px]">
            {t('home.content.hero.subtitle')}
          </p>
          <p className="text-white font-[900] md:text-[36px] text-[32px] text-center leading-[47.84px]">
            {t('home.content.hero.title')}
          </p>
          <div>
            {' '}
            <button
              className={classNames(
                ' px-[24px] py-[13px] font-bold rounded-[40px] bg-white mt-[24px] md:w-[388px] w-[375px]',
                {
                  'text-short': !userInfo,
                  'text-main': userInfo,
                }
              )}
              onClick={() => {
                onClickTextArea('short', '/short-video-editor')
              }}
            >
              {userInfo ? t('home.content.hero.startNow') : t('home.content.hero.signUpAndTry')}
            </button>
          </div>
        </div>
        <div className="home_first flex flex-col items-center gap-[16px] w-[343px] md:w-[816px] mb-[80px] md:mb-[80px]">
          <div className="flex flex-col items-center">
            <p className="md:text-[60px] text-[40px]">{t('home.content.description.title')}</p>
            <p className="text-[18px] text-center font-bold mt-[24px]">
              {t('home.content.description.subtitle')}
            </p>

            <button
              className={classNames(
                ' px-[24px] py-[13px] font-bold rounded-[40px] text-white mt-[24px]',
                {
                  'bg-short': !userInfo,
                  'bg-main': userInfo,
                }
              )}
              onClick={() => {
                onClickTextArea('short', '/short-video-editor')
              }}
            >
              {userInfo ? t('home.content.description.startNow') : t('home.content.description.signUpAndTry')}
            </button>
          </div>
        </div>
        <div className="home_second flex flex-col items-center gap-[16px] w-[343px] md:w-[816px] mb-[100px] ">
          <video
            playsInline
            autoPlay
            muted
            loop
            className="rounded-[10px]"
            src="https://s3.ap-northeast-2.amazonaws.com/pub.angelleague.io/fast_cut_front/video/text_video.mp4"
          />
        </div>
        <div className="home_second flex flex-col items-center gap-[16px] w-[343px] md:w-[816px] mb-[100px] ">
          <p className="text-[40px] font-[800] text-center">
{t('home.ai.title')}
          </p>
          <video
            playsInline
            autoPlay
            muted
            loop
            className="rounded-[40px]"
            src="https://s3.ap-northeast-2.amazonaws.com/pub.angelleague.io/fast_cut_front/video/runway.mp4"
          />
        </div>
        <div className="w-[100vw] flex justify-center items-end mb-[100px] relative">
          <img
            src={
              isMobile
                ? 'assets/img/home/mobile_home.png'
                : 'assets/img/gradient_bg.png'
            }
            alt="bg"
            className=" absolute -z-10"
          />
          <div className="home_second flex flex-col items-center gap-[16px] w-[343px] md:w-[816px] mb-[100px] z-30">
            <div className="flex flex-col items-center">
              <p
                className="md:text-[40px] text-[34px] font-[800] text-center
            "
              >
{t('home.content.platforms.subtitle')}
              </p>
              <div className="flex gap-6 mt-6">
                <img
                  src="assets/img/icon_shorts.png"
                  alt="short"
                  width={66}
                  height={66}
                />
                <img
                  src="assets/img/icon_instagram.png"
                  alt="short"
                  width={66}
                  height={66}
                />
                <img
                  src="assets/img/icon_naver_clip.png"
                  alt="short"
                  width={66}
                  height={66}
                />
                <img
                  src="assets/img/icon_tiktok.png"
                  alt="short"
                  width={66}
                  height={66}
                />
              </div>
              <p className="text-center mt-[18px] font-bold">
{t('home.content.platforms.waitingMessage')}
              </p>
              <div className="flex md:gap-[18px] gap-1 mt-6 justify-center">
                <video
                  controls
                  playsInline
                  autoPlay
                  muted
                  loop
                  className="border rounded-[4px]"
                  src="https://s3.ap-northeast-2.amazonaws.com/pub.angelleague.io/fast_cut_front/video/content_1.mp4"
                  width={isMobile ? 119.49 : 260}
                />
                <video
                  playsInline
                  controls
                  autoPlay
                  muted
                  loop
                  className="border rounded-[4px]"
                  src="https://s3.ap-northeast-2.amazonaws.com/pub.angelleague.io/fast_cut_front/video/content_2.mp4"
                  width={isMobile ? 119.49 : 260}
                />
                <video
                  playsInline
                  controls
                  autoPlay
                  muted
                  loop
                  className="border rounded-[4px]"
                  src="https://s3.ap-northeast-2.amazonaws.com/pub.angelleague.io/fast_cut_front/video/content_3.mp4"
                  width={isMobile ? 119.49 : 260}
                />
              </div>
            </div>
          </div>
        </div>{' '}
        <div className="home_third flex flex-col md:flex-row items-center w-[343px] md:w-[816px] mb-[100px] h-[650px] md:h-[383px] bg-[#F6F8FB] rounded-[20px] p-10  relative">
          <div className="flex flex-col justify-between w-full md:w-[50%] md:h-full">
            <div className="flex flex-col">
              <p className="font-bold text-[24px]">{t('home.content.platforms.title')}</p>
              <p className="mt-2">
                {t('home.content.platforms.description')}
              </p>
            </div>
            <div>
              <button
                className={classNames(
                  ' px-[24px] py-[13px] font-bold rounded-[40px] text-white mt-[24px]',
                  {
                    'bg-short': !userInfo,
                    'bg-main': userInfo,
                  }
                )}
                onClick={() => {
                  onClickTextArea('short', '/short-video-editor')
                }}
              >
                {userInfo ? t('home.content.platforms.startNow') : t('home.content.platforms.signUpAndTry')}
              </button>
            </div>
          </div>
          <div className="flex flex-col justify-end w-full md:w-[50%]">
            <img
              src="assets/img/img_group.png"
              alt="group"
              className="absolute -bottom-2 -right-2"
              width={338}
              height={335}
            />
          </div>
        </div>
        <div className="home_fourth flex flex-col items-center gap-[16px] w-[343px] md:w-[816px] mb-[80px] md:mb-[80px]">
          <div className="flex flex-col items-center">
            <p className="md:text-[48px] text-[34px] font-bold text-center">
              {t('home.content.steps.title')}
            </p>
          </div>
          <div className="flex flex-col md:flex-row gap-2 ">
            <div className="first flex flex-col bg-[#F6F8FB] p-5 rounded-[10px] gap-2 w-full md:w-[33%]  h-[240px] md:h-auto">
              <div className="flex justify-between">
                <div className="pb-6">
                  <p className="font-[800] text-[18px]">{t('home.content.steps.step1.title')}</p>
                  <p className="text-[14px]">
                    {t('home.content.steps.step1.description')}
                  </p>
                </div>
                <div>
                  <img
                    src="assets/img/img_first.png"
                    alt="first"
                    width={64}
                    height={67.89}
                  />
                </div>
              </div>
              <div className="bg-white rounded-[10px] p-4 ">
                <p className="font-bold text-main">
                  https://my.link.com / article/025/02452
                </p>
              </div>
            </div>
            <div className="second flex flex-col bg-[#F6F8FB] p-5 rounded-[10px] gap-2  w-full md:w-[33%] relative  h-[240px] md:h-auto">
              <div className="flex justify-between">
                <div>
                  <p className="font-[800] text-[18px]">{t('home.content.steps.step2.title')}</p>
                  <p className="text-[14px]">
                    {t('home.content.steps.step2.description')}
                  </p>
                </div>
                <div>
                  <img
                    src="assets/img/img_second.png"
                    alt="first"
                    width={64}
                    height={67.89}
                  />
                </div>
              </div>
              <div className=" ">
                <img
                  className=" absolute bottom-0 left-5"
                  src="assets/img/img_second_description.png"
                  alt="description"
                  width={126}
                  height={108}
                />
              </div>
            </div>{' '}
            <div className="third flex flex-col bg-[#F6F8FB] p-5 rounded-[10px] gap-2 w-full md:w-[33%] h-[240px] md:h-auto relative">
              <div className="flex justify-between">
                <div>
                  <p className="font-[800] text-[18px]">{t('home.content.steps.step3.title')}</p>
                  <p className="text-[14px]">
                    {t('home.content.steps.step3.description')}
                  </p>
                </div>
                <div>
                  <img
                    src="assets/img/img_third.png"
                    alt="first"
                    width={64}
                    height={67.89}
                  />
                </div>
              </div>
              <img
                className=" absolute bottom-0 right-0"
                src="assets/img/home/img_third_description.png "
                alt="description"
                width={170}
                height={272}
              />
            </div>
          </div>
        </div>
        <FAQ />
        <div className="flex flex-col p-[20px] items-center relative  bg-href w-[100vw] md:p-[40px]">
          <div className="flex flex-col items-center text-center gap-[8px] md:h-[119px]">
            <p className="text-[24px] text-white leading-[30px]">
              패스트컷으로 시작하는 쿠팡 파트너스 유튜브, 아직 망설여지나요?
            </p>
            <p className="font-[900] text-[36px] text-white leading-[44px]">
              지금 회원가입 하시고,
              <br />
              상품 영상 무료체험으로 모든 기능을 써보고 결정하세요.
            </p>
          </div>
          <div className="flex flex-col md:flex-row justify-end md:h-[60px] gap-[8px] text-[18px] font-bold mt-[32px]">
            <FreeButton
              className="w-[333px] h-[60px]  border-white border-[2px] rounded-[40px] text-white"
              onClick={() => {
                SetFreePlanModal((prev) => !prev)
              }}
            >
              체험내용 상세보기
            </FreeButton>
            <button
              className="w-[333px] h-[60px] bg-white  rounded-[40px] text-href"
              onClick={paymentFreePlan}
            >
              지금 바로 체험하기
            </button>
          </div>
        </div>
        <Modal isModal={isInAppBrowserModal}>
          <div className="bg-white w-[400px] h-[184px] p-[20px] border-t rounded-t-[20px]">
            <div className="flex flex-col items-center justify-center h-full gap-[24px]">
              <p className="font-bold text-[18px]">주의</p>
              <div className="flex flex-col leading-[22px]">
                <p className=" text-[14px] ">
                  인앱 브라우져환경에서는 회원가입이 안되요! <br />
                </p>
              </div>
            </div>
          </div>
          <div className="w-[400px] text-[14px]  h-[60px]  flex justify-center items-center">
            <button
              className="text-white w-full h-full bg-main rounded-b-[20px] border-b border-main font-bold"
              onClick={() => {
                handleOpenExternalBrowser()
              }}
            >
              확인
            </button>
          </div>
        </Modal>
      </div>
    </>
  )
}

export default Home
